export default "__VITE_ASSET__7w1y891l__"